module.exports = {
  BatchImportOrders: ' Batch import orders',
  BatchExportOrders: ' Batch export orders',
  BatchExportBills: ' Batch export bills',
  BusinessDate: ' Business Date',
  OperationDate: ' Operation Date',
  BillCreationDate: ' Bill creation date',
  BillInvoicingDate: ' Bill invoicing date',
  BillReceivingDate: ' Bill receiving date',
  BillVoucherGenerationDate: ' Bill voucher generation date',
  BillNo: ' Bill No.',
  BusinessStatus: ' Business status',
  BusinessType: ' Business type',
  OperatingBranch: ' Operating branch',
  ExportSettings: ' Export settings',
  AccountsReceivableBills: ' Accounts receivable bills',
  AccountsPayableBills: ' Accounts payable bills',
  ExportConditions: ' Export conditions',
  ReminderExportedAtOnce1000: ' Reminder: The number of rows exported at once cannot exceed 1000',
  ConfirmExport: ' Confirm export',
  ExportSuccessful: ' Export successful',
  BusinessCreationDate: ' Business creation date',
  Operation: ' Operation',
  BusinessNumber: ' Business number',
  DirectOrder: ' Direct order',
  MasterBillNumber: ' Master bill number',
  MasterBillSerialNumber: ' Master bill serial number',
  OceanFreight: ' Ocean freight',
  OceanExport: ' Ocean export',
  OceanImportdirectOrder: ' Ocean import (direct order)',
  AirFreight: ' Air freight',
  AirExport: ' Air export',
  AirImportdirectOrder: ' Air import (direct order)',
  All: ' All',
  Yes: ' Yes',
  No: ' No',
  DownloadExportResults: ' Download export results',
  EnterAirImport: ' Enter air import',
  EnterAirExport: ' Enter air export',
  EnterOceanImport: ' Enter ocean import',
  EnterOceanExport: ' Enter ocean export',
  DownloadCompleted: ' Download completed',
  Return: ' Return',
  File: ' File',
  ImportSettings: ' Import settings',
  OceanImport: ' Ocean import',
  AirCargoImport: ' Air Cargo Import',
  ImportFile: 'Import File',
  SelectFile: 'Select File',
  DownloadTemplate: 'Download Template',
  ReminderCannotExceed100Lines: 'Reminder: Single import cannot exceed 100 lines',
  ConfirmImport: 'Confirm Import',
  AirCargoImportTemplate: 'Air Cargo Import Template',
  UploadedInXLSOrFormat: 'Uploaded file must be in XLS or XLSX format!',
  DownloadImportResult: 'Download Import Result',
  DownloadComplete: 'Download Complete',
  EnterAirCargoImport: 'Enter Air Cargo Import',
  EnterSeaCargoImport: 'Enter Sea Cargo Import',
  TotalRecordsMeetTheConditions: ' Total of {0} records meet the export conditions',
  N0TheConditionsAndExported: ' {0} records do not meet the conditions and are not exported',
  Success0entriesFailure0entries: 'Success {0} entries, failure {1} entries.'
}
